import useSharedShowPageContext from '../../common/hooks/useSharedShowPageContext';
import useShow from '../../../../../hooks/shows/useShowFromURL';
import styles from './styles.module.scss';
import useShowEdgePlayback from '@/hooks/audio/useShowEdgePlayback';
import { sliceGenres } from '@/helpers/common';
import { createImageAltTextForShow } from '@/helpers/seo/shows';
import PlayPauseCTA from '@/components/component-library/Button/PlayPauseCTA';
import { SMALL, XLARGE } from '@/config/assets';
import SlateImage from '@/components/component-library/Image/KeakieImageSlate';
import Gradient, { GRADIENT_POSITION_BOTTOM } from '@/components/app/Gradient';
import SquareImage from '@/components/component-library/Image/KeakieImageSquare';
import LayoutWrapperVertical from '@/components/component-library/LayoutWrapperVertical';
import { classes } from '@/helpers/styling';
import LayoutWrapperHorizontal from '@/components/component-library/LayoutWrapperHorizontal';
import Text, { FONT_SIZE_140, FONT_SIZE_060 } from '@/components/component-library/Text';
import GenreBadges from '@/components/component-library/GenreBadges';
import TileGrain from '@/components/app/TileGrain';

const HeroSlateSection = () => {
  const { isListeningToThisShow } = useSharedShowPageContext();
  const { show, isLoading } = useShow();

  const {
    title,
    id: showId,
    genres,
    assets,
    story
  } = show;

  const {
    paused,
    isLoading: playButtonIsLoading,
    handleClickPlay: onClickPlayFromHero,
    seasonNumberToPlay,
    episodeNumberToPlay
  } = useShowEdgePlayback({ showId });

  const hidePlayButton = !playButtonIsLoading && !onClickPlayFromHero;

  return (
    <LayoutWrapperVertical
      className={ styles.topBanner }
      disableBottomOnMobile
    >
      <SlateImage
        alt={ createImageAltTextForShow({ show }) }
        assetSize={ SMALL }
        assetsObj={ assets }
        className={ classes(styles.topBannerBackground, { [styles.isLoaded]: true }) }
        disableBorderRadius
        loading={ isLoading }
      />
      <TileGrain />
      <Gradient
        className={ styles.topBannerGradient }
        directionReverse
        gradientBreadth='100%'
        position={ GRADIENT_POSITION_BOTTOM }
      />
      <div className={ styles.squareImageWrapper }>
        <SquareImage
          alt={ createImageAltTextForShow({ show }) }
          assetSize={ XLARGE }
          assetsObj={ assets }
          forceHighDensity
          hasBorderRadius={ false }
          loading={ isLoading }
        />
      </div>
      <LayoutWrapperHorizontal
        className='slate-info'
      >
        <Text
          bold
          className='title'
          loading={ isLoading }
          size={ FONT_SIZE_140 } useHeaderFont
        >
          { title }
        </Text>
        { !!story && (
          <Text
            bold
            className='description'
            loading={ isLoading }
            size={ FONT_SIZE_060 } useHeaderFont
          >
            { story }
          </Text>
        ) }
        <div
          className='slate-info-summary'
        >
          <GenreBadges
            enableLinks
            genres={ sliceGenres({
              genres,
              limit: 2
            }) }
            loading={ isLoading }
          />
        </div>
        <div
          className='slate-info-buttons-mobile'
        >
          { !hidePlayButton && (
            <PlayPauseCTA
              disabled={ playButtonIsLoading }
              episodeNumberToPlay={ episodeNumberToPlay }
              isCurrentlyPlayingShow={ isListeningToThisShow }
              loading={ playButtonIsLoading }
              onClick={ onClickPlayFromHero }
              paused={ paused }
              seasonNumber={ seasonNumberToPlay }
            />
          ) }
        </div>
      </LayoutWrapperHorizontal>
    </LayoutWrapperVertical>
  );
};

export default HeroSlateSection;